import * as React from "react";
import { Button as AntButton } from "antd";
import { IconProp, SizeProp, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ButtonProps as AntButtonProps } from "antd/lib/button";

interface ButtonProps extends AntButtonProps {
  // From AnchorButtonProps
  href?: string;
  target?: string;
  // --
  grey?: boolean;
  hideTextOnTablet?: boolean;
  columnDirection?: boolean;
  faIcon?: IconProp;
  faIconSize?: SizeProp;
  children?: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
  ({ faIcon, faIconSize = "1x", grey, children, hideTextOnTablet, columnDirection, ...rest }, ref) => {
    const buttonClass = classNames({ "btn-secondary": grey }, { "flex-column flex-all-center": columnDirection });
    const childrenClass = classNames(
      { "with-icon": faIcon && !columnDirection },
      { "hide-sm": hideTextOnTablet },
      { "top-icon": columnDirection }
    );
    const icon: IconProp = typeof faIcon === "string" ? ["far" as IconPrefix, faIcon] : faIcon;
    return (
      <AntButton ref={ref} className={buttonClass} {...rest}>
        {!rest.loading && faIcon && <FontAwesomeIcon fixedWidth={true} icon={icon} size={faIconSize} />}
        <span className={childrenClass}>{children}</span>
      </AntButton>
    );
  }
);

Button.displayName = "Button";
